/* eslint-disable @typescript-eslint/no-explicit-any */
import L from "leaflet";
import $ from "jquery";

interface ControlOverviewOptions extends L.ControlOptions {
  title?: string;
}

(L.Control as any).Overview = (L.Control as any).extend({
  // @section
  // @aka Control.Zoom options
  options: {
    position: "topright",
    title: "Overview",
  } as ControlOverviewOptions,

  onAdd: function (map: L.Map): HTMLElement {
    const a = $(
      '<div class="leaflet-control-custom-overview leaflet-bar" title="' +
        this.options.title +
        '"><a class="" javascript:void(0)></a></div>'
    );
    a.on("click", function () {
      map.fire("custom_overview", {});
    });
    a.on("dblclick", function (e) {
      (e.originalEvent as Event)?.stopPropagation();
    });

    return a[0];
  },

  onRemove: function (_map: L.Map) {
    // Cleanup if needed
  },
});

export const ControlOverview = function (
  opts?: ControlOverviewOptions
): any {
  return new (L.Control as any).Overview(opts);
};
